import { render, staticRenderFns } from "./HomeworkIntro.vue?vue&type=template&id=fbd0b2f0&scoped=true"
import script from "./HomeworkIntro.vue?vue&type=script&lang=js"
export * from "./HomeworkIntro.vue?vue&type=script&lang=js"
import style0 from "./HomeworkIntro.vue?vue&type=style&index=0&id=fbd0b2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd0b2f0",
  null
  
)

export default component.exports